import { baseURL } from './urlService';

const TOKEN_KEY = 'auth_token';

function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

async function request(method, url, body = null) {
  const config = {
    method,
    headers: { 'Content-Type': 'application/json' },
  };
  const token = getToken();
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  if (body) config.body = JSON.stringify(body);

  const res = await fetch(url, config);

  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: res.statusText }));
    throw new Error(err.message || err.error || `Request failed with status ${res.status}`);
  }

  if (res.status === 204) return null;
  return res.json();
}

export function get(url) { return request('GET', url); }
export function post(url, body) { return request('POST', url, body); }
export function put(url, body) { return request('PUT', url, body); }
export function del(url) { return request('DELETE', url); }

export { baseURL, getToken, TOKEN_KEY };